import {fromEvent} from 'rxjs';
import {setCookie} from "app/lib/cookies";
import * as qs from "app/lib/helperjs";

const NOTIFICATION_BAR_SELECTOR = '.notificationBar';
const NOTIFICATION_BAR_CLOSE_SELECTOR = '.closeNotificationBarButton';

export const NotificationBar = () => {
    const notificationBar = qs.querySelector(NOTIFICATION_BAR_SELECTOR);

    if (!notificationBar) {
        return;
    }

    const notificationBarCloseBtn = qs.querySelector(NOTIFICATION_BAR_CLOSE_SELECTOR);
    const notificationHash = notificationBar.dataset.hash;

    fromEvent(notificationBarCloseBtn, 'click')
        .subscribe(e => {
            e.preventDefault();
            setCookie('notif_'+notificationHash, true, 14);
            notificationBar.outerHTML = "";
            window.dispatchEvent(new Event('scroll'));
        });
};
